import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		width: '100%',
	},
	filtersRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
	},
	filterGroup: {
		display: 'flex',
		alignItems: 'center',
		flexShrink: 1,
		minWidth: 0,
	},
	comboBoxRightAutocompleteResponsive: {
		marginLeft: -1,
		width: 300,
		minWidth: 200,
		flexShrink: 1,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.light,
	},
	campaignBadge: {
		marginTop: THEME.spacing.sm,
		width: 280,
	},
	campaignBadgeWrapper: {
		position: 'relative',
		display: 'inline-flex',
		width: 280,
		alignItems: 'center',
		':hover .campaign-badge-remove': {
			opacity: 1,
		},
	},
	campaignBadgeRemove: {
		position: 'absolute',
		top: -6,
		right: -6,
		width: 16,
		height: 16,
		borderRadius: '50%',
		backgroundColor: THEME.colors.text.light,
		border: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		padding: 0,
		opacity: 0,
		transition: 'opacity 0.2s ease-in-out, background-color 0.2s ease-in-out',
		':hover': {
			backgroundColor: THEME.colors.text.main,
		},
	},
});
